<template lang="pug">
.report
  .section
    vant-row.light
      vant-col(:span="6") 股票名称
      vant-col.center(:span="6") 截止日期
      vant-col.center(:span="6") 营收同比增长率
      vant-col.center(:span="6") 净利润同比增长率
    vant-row(v-for="(item,i) in reportList" :key="i" type="flex" align="center")
      vant-col(:span="6")
        div {{ item.stock_name }}
        .light {{ item.stock_id }}
      vant-col.center(:span="6") {{ item.end_date }}
      vant-col.center(:span="6" :class="item.operating_revenue_yoy | valueColorFormat") {{ item.operating_revenue_yoy | parseValidRatio }}
      vant-col.center(:span="6" :class="item.net | valueColorFormat") {{ item.net | parseValidRatio }}
</template>

<script>
import { dateToDateStr } from '@utils/time_helper'
import { Row, Col } from 'vant'
import { parseValidRatio, valueColorFormat } from '@utils/values'

export default {
  name: 'Report',
  components: {
    VantRow: Row,
    VantCol: Col
  },
  props: {
    list: Array
  },
  filters: {
    parseValidRatio,
    valueColorFormat
  },
  computed: {
    reportList() {
      return this.list.map(item => {
        return {
          ...item,
          end_date: dateToDateStr(item.end_date),
          net: item.net_profit_yoy || item.np_parent_company_owners_yoy
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.van-row
  border-bottom 1px solid $border-color
  padding 1rem 0
</style>
